import React from 'react';
import { ISpeechVoiceSelectProps } from './types';
import { theme } from '../../../../common/styles/theme';
import { Box, MenuItem, Select, SelectChangeEvent, Stack } from '@mui/material';
import LangFlag from '../../shared/LangFlag/LangFlag';

export const SpeechVoiceSelect: React.FC<ISpeechVoiceSelectProps> = ({
	langs,
	voicesMap,
	userVoicesMap,
	onSave,
}) => {

	const handleVoiceChange = (
		{ target }: SelectChangeEvent,
		lang: string,
	) => {
		onSave(lang, target.value);
	}

	return (
		<Stack
			gap={.5}
			sx={{
				mt: 1,
			}}
		>
			<Box
				sx={{
					fontSize: theme.typography.subtitle1,
					color: theme.palette.grey[400],
				}}
			>
				Here are the languages with available voice options:
			</Box>
			{langs.map((lang) => {
				return (
					<Stack
						flexDirection={'row'}
						gap={.5}
						key={lang}
					>
						<LangFlag
							code={lang}
							showCode
						/>

						<Select
							value={userVoicesMap[lang] || ''}
							onChange={(e)=>handleVoiceChange(e, lang)}
							variant={'filled'}
							fullWidth
							displayEmpty
							sx={{
								flex: `1 1 100%`,
								minWidth: 0,
								height: theme.spacing(3.5),

								'.MuiInputBase-input': {
									p: `${theme.spacing(.5, 3, .5, 1)} !important`,
								},
							}}
						>
							{voicesMap[lang].map((voice) => {
								return (
									<MenuItem
										key={voice.voiceURI}
										value={voice.voiceURI}
									>
										{voice.name}
									</MenuItem>
								);
							})}
						</Select>
					</Stack>
				);
			})}

		</Stack>
	)

};
